import { render, staticRenderFns } from "./addRecommendModal.vue?vue&type=template&id=55accdf0&scoped=true"
import script from "./addRecommendModal.vue?vue&type=script&lang=js"
export * from "./addRecommendModal.vue?vue&type=script&lang=js"
import style0 from "./addRecommendModal.vue?vue&type=style&index=0&id=55accdf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55accdf0",
  null
  
)

export default component.exports